export function batchRequests<Arg, BatchResponse, SingleResponse>(
    batchHandler: (accumulatedArgs: Arg[]) => Promise<BatchResponse>,
    batchUnpack: (arg: Arg, batchResponse: BatchResponse) => SingleResponse,
    delay = 0,
) {
    let accumulateArgs: Arg[] = [];
    let batchPromise: Promise<BatchResponse> | undefined;

    return async (arg: Arg) => {
        accumulateArgs.push(arg);
        if (!batchPromise) {
            batchPromise = new Promise<BatchResponse>((resolve, reject) => {
                setTimeout(() => {
                    const batchHandlerPromise = batchHandler(accumulateArgs);
                    batchPromise = undefined;
                    accumulateArgs = [];
                    batchHandlerPromise.then(resolve, reject);
                }, delay);
            });
        }

        return batchUnpack(arg, await batchPromise);
    };
}
